import type { Totals } from '../types/GroupsArrayType';

const totalsModel: Totals = {
  shifts: 0,
  noShows: 0,
  sickCallouts: 0,
  events: 0,
  hours: 0,
  paidMinutes: 0,
};

export default totalsModel;
